import React, { createContext, useReducer } from 'react'

import productReducer from './ProductReducer'

const initialState = { products: false, loading: true, totalPages: 0 }

export const ProductContext = createContext(initialState)

export const ProductContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(productReducer, initialState)

  function getAllProducts(products, totalPages) {
    dispatch({
      type: 'GET_ALL_PRODUCTS',
      payload: products,
      totalPages: totalPages,
    })
  }

  function addProduct(product) {
    //console.log('CHECK : ', product)
    dispatch({
      type: 'ADD_PRODUCT',
      payload: product,
    })
  }

  function editProduct(product) {
    dispatch({
      type: 'EDIT_PRODUCT',
      payload: product,
    })
  }

  function removeProduct(id) {
    //console.log('ID : ', id)
    dispatch({
      type: 'REMOVE_PRODUCT',
      payload: id,
    })
  }

  return (
    <ProductContext.Provider
      value={{
        getNewProducts: getAllProducts,
        products: state.products,
        addNewProduct: addProduct,
        editNewProduct: editProduct,
        deleteNewProduct: removeProduct,
        totalPages: state.totalPages,
      }}
    >
      {children}
    </ProductContext.Provider>
  )
}
